import React from 'react';
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import {
  Box,
  Alert,
  Fade,
  AlertIcon,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Button
} from '@chakra-ui/react'
import { VARIANT_COLOR } from "../../../config";

const logInSchema = yup.object().shape({
  email: yup.string().email("Entered value does not match email format").required("Email is required"),
  password: yup.string().required("Password is required"),
});

export default function LoginInForm({ onSubmit, logInError, logInPending }) {
  const { handleSubmit, errors, register } = useForm({
    mode: "all",
    resolver: yupResolver(logInSchema)
  });


  return (
    <Box my={8} textAlign='left'>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl isInvalid={errors.email}>
          <FormLabel>Email address</FormLabel>
          <Input
            placeholder='Enter your email address'
            name="email"
            ref={register} />
          <FormErrorMessage>
            {errors.email && errors.email.message}
          </FormErrorMessage>
        </FormControl>
        <FormControl mt={4} isInvalid={errors.password}>
          <FormLabel>Password</FormLabel>
          <Input
            type='password'
            placeholder='Enter your password'
            name="password"
            ref={register} />
          <FormErrorMessage>
            {errors.password && errors.password.message}
          </FormErrorMessage>
        </FormControl>
        {logInError ?
          <Fade in={logInError}>
            <Alert status="error" mt={4} p={3} borderRadius={5}>
              <AlertIcon />
              {logInError}
            </Alert>
          </Fade>
          :
          null
        }
        <Button
          colorScheme={VARIANT_COLOR}
          width='full' mt={4}
          type="submit"
          isLoading={logInPending}
          loadingText="Submitting.."
        >
          Sign In
        </Button>

      </form>
    </Box>
  )
}
